import { ROLE_TYPE } from '@utils/enums';
import { useFeatureFlagEnabled } from '@components/Atoms/FeatureFlagGuard/hooks';
import { useMemo } from 'react';
import { useUser } from '@reducers/user/hooks';
import { useCurrentSection } from '@reducers/sections/hooks';

export const useLearnosityExamAccess = () => {
  const section = useCurrentSection();

  if (!section || Object.keys(section || {}).length === 0) {
    return true;
  }

  return section.learnosity_exam;
};

export const useExamV2Access = ({ suspense = false }: { suspense?: boolean } = {}) => {
  const isExamV2Enabled = useFeatureFlagEnabled({
    featureName: 'exam-v2',
    suspense,
  });

  return isExamV2Enabled;
};

const ShowIfLearnosityExamFlagEnabled = ({ children, fallback }) => {
  const isEnabled = useLearnosityExamAccess();
  const { role } = useUser();

  const hasRolePermission = useMemo(
    () => [ROLE_TYPE.INSTRUCTOR, ROLE_TYPE.STUDENT, ROLE_TYPE.ADMIN].includes(role),
    [role],
  );

  if (!isEnabled || !hasRolePermission) {
    return fallback;
  }

  return children;
};

export default ShowIfLearnosityExamFlagEnabled;
